/* eslint-disable no-shadow */
/* eslint-disable import/no-cycle */
import ApiService from '@/services/api.service';
import { apiEndpoint } from '@/shared';
import {
  ForbiddenError, HttpError, PMSError, ValidationError,
} from '@/errors';

const endpoint = `${apiEndpoint}/pages`;
const extranetApiEndpoint = `${apiEndpoint}/extranet-api/pages`;
const extranetApiEndpointFields = `${apiEndpoint}/extranet-api/fields`;

function handleApiError(commit, error) {
  const { status, data } = error.response;
  let err = error;
  switch (status) {
    case 400: // BadRequest
      err = new HttpError(status, data.message);
      break;
    case 403:
      err = new ForbiddenError(status, data.message);
      break;
    case 409: // PMSError
      err = new PMSError(status, data.message);
      break;
    case 422:
      err = new ValidationError(status, data.message, data.errors);
      break;
    case 500:
      err = new Error(data.message);
      break;
    default:
      break;
  }
  // commit('update', err);
  throw err;
}

const state = {
  pages: null,
  loading: true,
  pending: false,
};

const getters = {
  // loaded: (state) => (state.rooms != null && state.images != null && !state.pending),
  pages: (state) => (state.pages != null ? state.pages : []),
  pending: (state) => (state.pending),
};

const mutations = {
  clearErrors() {
    state.loading = false;
    state.pending = false;
  },
  updatePages(state, data) {
    state.loading = false;
    state.pending = false;
    state.pages = data;
  },
  beforeRequest(state) {
    state.pending = true;
  },
  beforeUpdate(state) {
    state.loading = true;
  },
  afterUpdate(state) {
    state.loading = false;
  },
};

const actions = {
  async updatePage({ commit }, payload) {
    const { id, displayOrder } = payload;
    commit('beforeUpdate');
    try {
      const response = await ApiService.put(`${endpoint}/${id}`, { displayOrder });
      commit('updatePages', response.data);
      return response;
    } catch (error) {
      throw new Error(error);
    }
  },
  async fetchPagesByActiveUserAndProperty({ commit }) {
    try {
      commit('beforeRequest');
      const { data } = await ApiService.get(`${extranetApiEndpoint}/user/property`);
      commit('updatePages', data.data);
    } catch (error) {
      commit('error', error);
      handleApiError(commit, error);
    }
  },

  async fetchAllPages({ commit }) {
    try {
      commit('beforeUpdate');
      const { data } = await ApiService.get(`${extranetApiEndpoint}`);
      commit('updatePages', data.data);
    } catch (error) {
      commit('error', error);
      handleApiError(commit, error);
    }
  },
  async savePage({ commit }, payload) {
    try {
      commit('beforeUpdate');
      await ApiService.post(`${extranetApiEndpoint}`, payload);
      commit('afterUpdate');
    } catch (error) {
      commit('error', error);
      handleApiError(commit, error);
    }
  },
  async saveField({ commit }, payload) {
    try {
      commit('beforeUpdate');
      await ApiService.post(`${extranetApiEndpointFields}`, payload);
      commit('afterUpdate');
    } catch (error) {
      commit('error', error);
      handleApiError(commit, error);
    }
  },
  async deletePage({ commit }, id) {
    try {
      commit('beforeUpdate');
      await ApiService.delete(`${extranetApiEndpoint}/${id}`);
      commit('afterUpdate');
    } catch (error) {
      commit('afterUpdate');
      handleApiError(commit, error);
    }
  },
  async deleteField({ commit }, id) {
    try {
      commit('beforeUpdate');
      await ApiService.delete(`${extranetApiEndpointFields}/${id}`);
      commit('afterUpdate');
    } catch (error) {
      commit('afterUpdate');
      handleApiError(commit, error);
    }
  },
  async updatePages({ commit }, payload) {
    try {
      commit('beforeUpdate');
      const { data } = await ApiService.put(`${extranetApiEndpoint}/update-order`, { pages: payload });
      commit('updatePages', data.data);
    } catch (error) {
      commit('error', error);
      handleApiError(commit, error);
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
